module.exports = __webpack_public_path__ + "media/images/cover/housing-square-0e547fa25e539d39013a591f9467ff93.jpg";